export const calendarAspectRules = [
    {
        name: "conjunction",
        label: "Соединение",
        shortLabel: "0",
        angle: 0,
        orb: 8,
        weight: 1.18,
        kind: "neutral",
        polarity: 0,
        color: "#f5c66b",
        enabled: true,
        marker: true,
    },
    {
        name: "opposition",
        label: "Оппозиция",
        shortLabel: "180",
        angle: 180,
        orb: 7,
        weight: 1.08,
        kind: "tension",
        polarity: -1,
        color: "#e46f83",
        enabled: true,
        marker: true,
    },
    {
        name: "square",
        label: "Квадрат",
        shortLabel: "90",
        angle: 90,
        orb: 6,
        weight: 1.14,
        kind: "tension",
        polarity: -1,
        color: "#ff8066",
        enabled: true,
        marker: true,
    },
    {
        name: "trine",
        label: "Трин",
        shortLabel: "120",
        angle: 120,
        orb: 6,
        weight: 0.9,
        kind: "harmony",
        polarity: 1,
        color: "#7dd8d1",
        enabled: true,
        marker: false,
    },
    {
        name: "sextile",
        label: "Секстиль",
        shortLabel: "60",
        angle: 60,
        orb: 5,
        weight: 0.68,
        kind: "harmony",
        polarity: 1,
        color: "#9ed17b",
        enabled: true,
        marker: false,
    },
    {
        name: "quincunx",
        label: "Квиконс",
        shortLabel: "150",
        angle: 150,
        orb: 3,
        weight: 0.58,
        kind: "tension",
        polarity: -1,
        color: "#d59bff",
        enabled: false,
        marker: false,
    },
    {
        name: "semiSquare",
        label: "Полуквадрат",
        shortLabel: "45",
        angle: 45,
        orb: 2.5,
        weight: 0.46,
        kind: "tension",
        polarity: -1,
        color: "#ef9a72",
        enabled: false,
        marker: false,
    },
    {
        name: "sesquiquadrate",
        label: "Полутораквадрат",
        shortLabel: "135",
        angle: 135,
        orb: 2.5,
        weight: 0.48,
        kind: "tension",
        polarity: -1,
        color: "#e493a0",
        enabled: false,
        marker: false,
    },
    {
        name: "semiSextile",
        label: "Полусекстиль",
        shortLabel: "30",
        angle: 30,
        orb: 2,
        weight: 0.32,
        kind: "harmony",
        polarity: 1,
        color: "#b5ca78",
        enabled: false,
        marker: false,
    },
    {
        name: "quintile",
        label: "Квинтиль",
        shortLabel: "72",
        angle: 72,
        orb: 2,
        weight: 0.34,
        kind: "harmony",
        polarity: 1,
        color: "#a6b2ff",
        enabled: false,
        marker: false,
    },
    {
        name: "biQuintile",
        label: "Биквинтиль",
        shortLabel: "144",
        angle: 144,
        orb: 2,
        weight: 0.34,
        kind: "harmony",
        polarity: 1,
        color: "#b8a6ff",
        enabled: false,
        marker: false,
    },
];
export const conjunctionTonePlanets = {
    hard: ["mars", "saturn", "uranus", "pluto"],
    soft: ["sun", "moon", "venus", "jupiter"],
};
//# sourceMappingURL=data:application/json;base64,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